/**
 * Import Lib & assets
 */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const SVG = styled.svg`
  width: 22px;
  height: 22px;

  ${t.mixins.sm(`
    transform: scale(0.63) translateY(10px);
  `)}
`;

/**
 * info component is..
 */

const Svg__info = ({ size }) => (
  <SVG xmlns="http://www.w3.org/2000/svg" style={{ transform: `scale(${size / 22})` }}>
    <path
      fillRule="evenodd"
      fill="#04528D"
      d="M3.154 4.032c-4.14 4.141-4.14 10.856 0 14.997 4.141 4.141 10.857 4.141 14.998 0 4.142-4.141 4.142-10.856 0-14.997C14.011-.11 7.295-.11 3.154 4.032zm7.924 1.343c.896 0 1.613.739 1.613 1.634 0 .895-.74 1.634-1.613 1.634a1.648 1.648 0 01-1.633-1.656c0-.896.739-1.612 1.633-1.612zm2.307 10.946a1.08 1.08 0 01-.225.38c-.581.605-1.299.963-2.149.963-.402 0-.783 0-1.186-.067-.65-.09-1.477-.896-1.365-1.746.089-.582.178-1.164.269-1.746.178-1.008.357-2.037.537-3.044 0-.068.022-.135.022-.202 0-.425-.135-.582-.559-.627a4.537 4.537 0 01-.538-.089c-.202-.067-.313-.246-.291-.403.022-.179.134-.291.359-.336.111-.022.246-.022.379-.022h3.091c.379 0 .603.179.603.559 0 .314-.044.627-.111.94-.203 1.164-.427 2.306-.627 3.47-.067.381-.157.761-.202 1.142-.022.179 0 .38.045.559.068.246.247.381.492.358.202-.022.403-.089.605-.179.157-.067.291-.179.447-.224.269-.089.471.068.404.314z"
    />
  </SVG>
);

export default Svg__info;

Svg__info.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Svg__info.defaultProps = {
  style: {},
};

/*
    import Svg__info from 'components/svg/info/svg__info'
    <Svg__info />
  */
